/* utils */
function formatMoney(cents) {
  const euros = (cents / 100).toFixed(2);
  return euros.replace('.', ',') + ' €';
}
function getFocusable(container) {
  return Array.from(
    container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )
  );
}

/* open/close with focus trap */
function openPills(card, btn, pills, { topInfo, subtitle }) {
  pills.classList.add('show-pills');
  pills.removeAttribute('inert');
  pills.setAttribute('aria-hidden', 'false');
  btn.setAttribute('aria-expanded', 'true');

  if (topInfo) topInfo.classList.add('hide-top-info');
  if (subtitle) subtitle.classList.add('hide-subtitle');

  const focusables = getFocusable(pills);
  const first = focusables[0] || pills;
  const last  = focusables[focusables.length - 1] || pills;

  function onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closePills(card, btn, pills, { topInfo, subtitle });
      btn.focus();
      return;
    }
    if (e.key === 'Tab') {
      if (focusables.length === 0) { e.preventDefault(); return; }
      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      }
    }
  }
  pills._a11yTrapHandler = onKeydown;
  document.addEventListener('keydown', onKeydown, true);

  first.focus({ preventScroll: true });
}

function closePills(card, btn, pills, { topInfo, subtitle }) {
  pills.classList.remove('show-pills');
  pills.setAttribute('inert', '');
  pills.setAttribute('aria-hidden', 'true');
  btn.setAttribute('aria-expanded', 'false');

  if (topInfo) topInfo.classList.remove('hide-top-info');
  if (subtitle) subtitle.classList.remove('hide-subtitle');

  // ensure the trigger becomes visible again after any close (ESC, mouseleave, etc.)
  if (btn) btn.style.removeProperty('display');

  if (pills._a11yTrapHandler) {
    document.removeEventListener('keydown', pills._a11yTrapHandler, true);
    delete pills._a11yTrapHandler;
  }
}

/* submit helper */
function submitVariantFromPill(pill) {
  const productCard = pill.closest('.product-card');
  if (!productCard) return;

  const form = productCard.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  const variantInput = form.querySelector('input[name="id"].product-variant-id');
  if (!variantInput) return;

  variantInput.value = pill.getAttribute('data-variant-id');
  form.dispatchEvent(new Event('submit', { bubbles: true }));

  pill.classList.remove('variant-pill--armed');
  delete pill.dataset.armed;
}

/* init */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card').forEach(card => {
    const btn      = card.querySelector('.select-variant-btn');
    const pills    = card.querySelector('.variant-pills.selectable');
    const topInfo  = card.querySelector('.top-info');
    const subtitle = card.querySelector('.product-subtitle');
    let hideTimeout;

    if (pills) {
      pills.setAttribute('inert', '');
      pills.setAttribute('aria-hidden', 'true');
    }
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      // guard: make sure the trigger is visible on load
      btn.style.removeProperty('display');
    }
    if (!btn || !pills) return;

    btn.addEventListener('click', () => {
      openPills(card, btn, pills, { topInfo, subtitle });
      btn.style.display = 'none';
    });

    card.addEventListener('mouseleave', () => {
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        const active = document.activeElement;
        if (active && pills.contains(active)) return;
        closePills(card, btn, pills, { topInfo, subtitle });
      }, 3000);
    });

    card.addEventListener('mouseenter', () => clearTimeout(hideTimeout));
  });
});

/* TOUCH ONLY: two-tap preview then submit on second tap */
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('pointerup', (event) => {
    const pill = event.target.closest('.variant-pill--clickable');
    if (!pill) return;

    if (event.pointerType !== 'touch') return;

    const productCard = pill.closest('.product-card');
    if (!productCard) return;

    const priceEl        = productCard.querySelector('.current-price');
    const comparePriceEl = productCard.querySelector('.compare-price');
    const pricePerKgEl   = productCard.querySelector('.product__price-per-kg');

    const previewFromPill = () => {
      const price     = parseInt(pill.dataset.price, 10);
      const compareAt = parseInt(pill.dataset.compareAtPrice, 10);
      const weight    = parseFloat(pill.dataset.weight);

      if (priceEl && !isNaN(price)) priceEl.innerHTML = formatMoney(price);
      if (comparePriceEl) {
        if (!isNaN(compareAt) && compareAt > price) {
          comparePriceEl.innerHTML = formatMoney(compareAt);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (pricePerKgEl) {
        if (!isNaN(weight) && weight > 0) {
          const pricePerKg = Math.round((price * 1000) / weight);
          pricePerKgEl.innerHTML = formatMoney(pricePerKg) + ' / kg';
          pricePerKgEl.style.display = '';
        } else {
          pricePerKgEl.style.display = 'none';
        }
      }
    };

    if (pill.dataset.armed !== '1') {
      pill.parentElement.querySelectorAll('.variant-pill--clickable').forEach(p => {
        if (p !== pill) {
          p.classList.remove('variant-pill--armed');
          delete p.dataset.armed;
          if (p._armTimer) clearTimeout(p._armTimer);
        }
      });

      previewFromPill();
      pill.dataset.armed = '1';
      pill.classList.add('variant-pill--armed');

      if (pill._armTimer) clearTimeout(pill._armTimer);
      pill._armTimer = setTimeout(() => {
        pill.classList.remove('variant-pill--armed');
        delete pill.dataset.armed;
      }, 4000);

      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    submitVariantFromPill(pill);
    event.preventDefault();
    event.stopImmediatePropagation();
  });
});

/* hover preview restore */
function setupVariantHoverHandlers(context = document) {
  context.querySelectorAll('.product-card').forEach(card => {
    const priceEl = card.querySelector('.current-price');
    const comparePriceEl = card.querySelector('.compare-price');
    const pricePerKgEl = card.querySelector('.product__price-per-kg');

    const originalPrice = priceEl?.innerHTML;
    const originalComparePrice = comparePriceEl?.innerHTML;
    const originalCompareDisplay = comparePriceEl?.style.display || '';
    const originalPricePerKg = pricePerKgEl?.innerHTML;
    const originalPricePerKgDisplay = pricePerKgEl?.style.display || '';

    card.querySelectorAll('.variant-pill--clickable').forEach(pill => {
      pill.addEventListener('mouseenter', () => {
        const price = parseInt(pill.dataset.price, 10);
        const compareAt = parseInt(pill.dataset.compareAtPrice, 10);
        const weight = parseFloat(pill.dataset.weight);

        if (priceEl && !isNaN(price)) priceEl.innerHTML = formatMoney(price);

        if (comparePriceEl) {
          if (!isNaN(compareAt) && compareAt > price) {
            comparePriceEl.innerHTML = formatMoney(compareAt);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        if (pricePerKgEl) {
          if (!isNaN(weight) && weight > 0) {
            const pricePerKg = Math.round((price * 1000) / weight);
            pricePerKgEl.innerHTML = formatMoney(pricePerKg) + ' / kg';
            pricePerKgEl.style.display = '';
          } else {
            pricePerKgEl.style.display = 'none';
          }
        }
      });

      pill.addEventListener('mouseleave', () => {
        if (priceEl) priceEl.innerHTML = originalPrice;
        if (comparePriceEl) {
          comparePriceEl.innerHTML = originalComparePrice;
          comparePriceEl.style.display = originalCompareDisplay;
        }
        if (pricePerKgEl) {
          pricePerKgEl.innerHTML = originalPricePerKg;
          pricePerKgEl.style.display = originalPricePerKgDisplay;
        }
      });
    });
  });
}
document.addEventListener('DOMContentLoaded', () => { setupVariantHoverHandlers(); });

/* open via select-variant button */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.select-variant-btn');
  if (!trigger) return;

  const card = trigger.closest('.product-card');
  if (!card) return;

  const pills = card.querySelector('.variant-pills.selectable');
  const topInfo = card.querySelector('.top-info');
  const subtitle = card.querySelector('.product-subtitle');

  if (pills) {
    openPills(card, trigger, pills, { topInfo, subtitle });
    trigger.style.display = 'none';
  }
});

/* mouse + keyboard (Enter/Space): submit on click */
document.addEventListener('click', (event) => {
  const pill = event.target.closest('.variant-pill--clickable');
  if (!pill) return;
  submitVariantFromPill(pill);
});